/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import {useTranslation} from 'react-i18next'
import swal from 'sweetalert'
import {KTSVG} from '../../../../_metronic/helpers'
import axios from 'axios'
import {Spinner} from 'react-bootstrap'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import {getAccessesIncoterm} from '../../../../api/modules/access/access'
import {getDetailIncoterm} from '../../../../api/modules/master-data/master_2'
import {fetchIncoterms, headers} from '../../../../services/fetcher'
import {SelectPageSize} from '../../../../components/SelectPageSize/SelectPageSize'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {
  filterSelector,
  resetFilterIncoterms,
  setFilterIncoterms,
  setIsFetchData,
} from '../../../../redux/slices/filterSlices'
import {objToParams} from '../../../../utils/objToParams'
import Pagination from '../../component/Pagination'
import {RowFilter} from './RowFilter'
import * as TableUI from '../../../../components/Table/Table'
import {useRowTable} from '../../../../hooks/useRowTable'
import {StyledCard} from '../../../../components/StyledCard'
import {StyledButtonGroups} from '../../../../components/StyledButtonGroups'
import {HakAkses} from '../../../../components/mikro/getHakAkses'
import {authSelector} from 'src/redux/slices/authSlices'

type Props = {
  className: string
}

const TableIncoterm: React.FC<Props> = ({className}) => {
  const {roleId} = useAppSelector(authSelector)
  const {filterIncoterms} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const hakAkses = HakAkses()

  const {RowEmptyData, RowLoader, RowErrorFetch} = useRowTable({
    colSpan: 3,
    onReloadTable: () => handleResetTable(),
  })

  const edit = (props: any) => (
    <Tooltip id='button-tooltip' {...props}>
      {t('ubah')}
    </Tooltip>
  )

  const test = (props: any) => (
    <Tooltip id='button-tooltip' {...props}>
      {t('Hapus')}
    </Tooltip>
  )

  const [show1, setShow1] = useState(false)
  const handleClose1 = () => setShow1(false)
  const handleShow1 = () => setShow1(true)

  const {t} = useTranslation()

  const [incoterm, setIncoterm] = useState<any[]>([])
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [accesses, setAccesses] = useState<any>()
  const [btnLoading, setBtnLoading] = useState(false)
  const [actived, setActived] = useState(false)
  const [isError, setIsError] = useState(false)

  const rowNumber = useMemo(() => {
    const per = filterIncoterms?.per_page ?? 5
    return page * per - per
  }, [filterIncoterms, page])

  const onFetchIncoterms = useCallback(() => {
    setLoading(true)
    setIsError(false)
    fetchIncoterms(filterIncoterms)
      .then((res) => {
        setIncoterm(res.data.data.data)
        setPage(res.data.data.current_page)
        setNumberURL(res.data.data.links)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filterIncoterms])

  useEffect(() => {
    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccessesIncoterm(roleId)
      setAccesses(res.data.data)
    }

    getAccessMenu()
  }, [])

  const paginateNumber = async (url: string) => {
    if (!url) return

    try {
      setLoading(true)

      const token = localStorage.getItem('token') as string
      const endpoint = `${url}&${objToParams(filterIncoterms)}`
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })
      const data = res.data.data

      setIncoterm(data.data)
      setPage(data.current_page)
      setNumberURL(data.links)
    } catch (error) {
      setIsError(true)
    } finally {
      setLoading(false)
    }
  }

  const [isUpload, setIsUpload] = useState(false)

  const deletePrice = async (id: any) => {
    swal({
      title: `${t('Are You Sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    })
      .then(async (willDelete) => {
        if (willDelete) {
          axios
            .delete(
              `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/incoterm/delete/${id}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('token')}`,
                  apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
                  Accept: 'application/json',
                  'Access-Control-Allow-Origin': '*',
                },
              }
            )
            .then((response) => {
              swal({
                title: `${t('Incoterm Berhasil di Hapus')}`,
                icon: 'success',
              })
              if (!response.data.error) {
                setIsUpload(true)

                setActived(!actived)
                onFetchIncoterms()
              }
            })
            .catch((error) => {
              swal({
                title: `${t(error.response.message)}`,
                icon: 'error',
              })
            })
        }
      })
      .catch((error) => {
        swal({
          title: `${t(error.response.message)}`,
          icon: 'error',
        })
      })
  }

  const [editId, setEditId] = useState<any>('')
  const [editName, setEditName] = useState('')
  const [editCode, setEditCode] = useState('')

  const handleEdit = async (id: any) => {
    handleShow1()
    setEditId(id)

    const res = await getDetailIncoterm(id)
    const data = res.data.data

    setEditName(data.name)
    setEditCode(data.code)
  }

  const editIncoterm = async () => {
    setBtnLoading(true)
    axios
      .put(
        `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/incoterm/edit/${editId}`,
        {
          name: editName,
          code: editCode,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((response) => {
        setIsUpload(true)
        swal({
          title: `${t('Incoterm Berhasil di Ubah')}`,
          icon: 'success',
        })
        handleClose1()
        setActived(!actived)
        onFetchIncoterms()
      })
      .catch((error) => {
        swal({
          title: `${t(error.response.data.message.validation_errors.code[0])}`,
          icon: 'error',
        })
      })
      .finally(() => {
        setBtnLoading(false)
      })
  }

  const handleResetTable = () => {
    dispatch(resetFilterIncoterms())
  }

  const handlePageSizeChange = (value: number | null | undefined) => {
    dispatch(setFilterIncoterms({...filterIncoterms, per_page: value ?? 5}))
  }

  useEffect(() => {
    const getData = setTimeout(onFetchIncoterms, 1000)
    return () => clearTimeout(getData)
  }, [onFetchIncoterms])

  useEffect(() => {
    return () => {
      handleResetTable()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <SelectPageSize
            initialValue={filterIncoterms?.per_page ?? 5}
            onChange={(value: any) => handlePageSizeChange(value?.value)}
          />
        }
      />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <tr>
              <th>{t('No')}</th>
              <th>{t('kode')}</th>
              <th>{t('order-aksi')}</th>
            </tr>
          </TableUI.THead>
          <TableUI.TBody>
            <RowFilter />
            {loading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : incoterm.length === 0 ? (
              <RowEmptyData />
            ) : (
              incoterm.map((incoterms, _index) => (
                <tr key={incoterms?.id ?? _index}>
                  <td>{_index + 1 + rowNumber}</td>
                  <td>{incoterms.code}</td>
                  <td>
                    <div className='d-flex justify-content-center'>
                      {hakAkses?.update && (
                        <OverlayTrigger
                          placement='bottom'
                          delay={{show: 250, hide: 400}}
                          overlay={edit}
                        >
                          <button
                            onClick={() => handleEdit(incoterms.id)}
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2'
                            title={t('ubah')}
                          >
                            <KTSVG path='/media/icons/duotune/pencil-fill.svg' />
                          </button>
                        </OverlayTrigger>
                      )}
                      {hakAkses?.delete && (
                        <OverlayTrigger
                          placement='bottom'
                          delay={{show: 250, hide: 400}}
                          overlay={test}
                        >
                          <button
                            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                            title={t('Hapus')}
                            onClick={() => deletePrice(incoterms.id)}
                          >
                            <KTSVG path='/media/icons/duotune/trash-fill.svg' />
                          </button>
                        </OverlayTrigger>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal show={show1} onHide={handleClose1} backdrop='static' keyboard={false} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t('ubah')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>{t('kode')}</Form.Label>
            <Form.Control
              type='text'
              value={editCode}
              onChange={(e: any) => setEditCode(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-3' controlId='formBasicEmail'>
            <Form.Label>{t('Name')}</Form.Label>
            <Form.Control
              type='text'
              value={editName}
              onChange={(e: any) => setEditName(e.target.value)}
            />
          </Form.Group>
          <div className='d-flex justify-content-end'>
            <Button variant='primary' onClick={editIncoterm} disabled={btnLoading}>
              {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('ubah')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {TableIncoterm}
